module.exports = __webpack_public_path__ + "img/127.4d07fade.svg";